// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".progress-circular--center[data-v-3202914d]{margin-top:18%;margin-left:50%;transform:translateX(-50%)}.maincam[data-v-3202914d]{position:relative;width:100%;height:100%;background-color:#000}", ""]);
// Exports
module.exports = exports;
